import * as React from "react";


export default function MonitoringSessionsPage() {
  return (
    <h1>
      title="Monitoring • Sessions"
      subtitle="All drip / urine sessions list, filters, status, assigned device, start/end times."
    </h1>
  );
}